import {useMatchMedia} from '@pexip/hooks';

import {BELOW_360} from '../../constants/mediaQueries';

export const useBelow360 = () => useMatchMedia(BELOW_360);
